import useWindowDimensions from "./hooks/windowDimensions";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Layout from "./layout/layout";
import "./App.css"
import "./assets/styles/reset.css"

function App() {
  const [dismissMessage, setDismissMessage] = useState(true);
  const { width } = useWindowDimensions();
  let smMessage = "*A tattoo is a permanent reminder of a temporary feeling.";
  let lgMessage = "*A tattoo is a permanent reminder of a temporary feeling *Art is the most beautiful way to express yourself";

  return (
    <div className="App">
      {dismissMessage ? <div className="marquee"><span>{width < 600 ? smMessage: lgMessage} <button className="marquee-btn" onClick={() => setDismissMessage(!dismissMessage)}>dismiss</button></span></div> : null }
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
